export const PROD = true 
export const HOST = PROD ? 'https://api.lemon.law' : 'http://localhost:3011'
